import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12ebba71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-account-wrapper" }
const _hoisted_2 = { class: "form-content" }

import { ref } from 'vue'

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Button from '@/popup/components/shared/Button.vue'
import { Description, Label } from '@/popup/components/shared/Form/Form'
import ConfirmPassword from '@/popup/components/shared/Password/ConfirmPassword.vue'
import { InternalMethods } from '@/shared/apis/messages'

type Emits = {
  (event: InternalMethods.CONFIRM_CHANGE_PASSWORD, value: string): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmChangePassword',
  setup(__props, { emit: __emit }) {

const emits = __emit

const password = ref('')
const isPassed = ref(false)

const onPasswordChange = (updatedPassword: string, passed: boolean) => {
  isPassed.value = passed
  password.value = updatedPassword
}

const onSubmit = () => {
  if (!password.value || !isPassed.value) return
  emits(InternalMethods.CONFIRM_CHANGE_PASSWORD, password.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('authenticate.password.label')), 1 /* TEXT */),
        _createElementVNode("form", {
          onSubmit: _withModifiers(onSubmit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(Label), {
              "extra-class": "is-title mb-2",
              label: _ctx.$t('create_new_account.confirm_password')
            }, null, 8 /* PROPS */, ["label"]),
            _createVNode(_unref(Description), {
              description: _ctx.$t('create_new_account.confirm_password_info')
            }, null, 8 /* PROPS */, ["description"]),
            _createVNode(ConfirmPassword, { onUpdatePassword: onPasswordChange })
          ]),
          _createVNode(Button, {
            disabled: !password.value || !isPassed.value,
            variant: "primary",
            "is-full-width": true,
            type: "submit",
            onClick: onSubmit
          }, {
            default: _withCtx(() => [
              _createVNode(SvgIcon, {
                class: "mr-2",
                color: "var(--neutral-100)",
                name: "unlocked",
                height: "24",
                width: "24"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('settings.password.update_password')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled"])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})